import { LOGOUT_URL } from '@unifyapps/network/auth/const';
import type { IdentityProvider } from '@unifyapps/network/auth/types';
import { useGetQueryMeta } from '@unifyapps/network/hooks/useGetQueryMeta';
import { executeFetch } from '@unifyapps/network/utils/fetch';
import { useCallback } from 'react';

export const useExecuteLogout = () => {
  const queryMeta = useGetQueryMeta();

  const onLogout = useCallback(() => {
    // using the logout api to logout the user, instead of redirecting to the /auth/logout
    // since the direct results into an rsc call which is unexpected.
    // the DPoP key is cleared by the afterResponse hook, not here — see dpopKey.ts
    return executeFetch<IdentityProvider[]>(
      { url: LOGOUT_URL, method: 'POST' },
      { meta: queryMeta },
    );
  }, [queryMeta]);

  return { onLogout };
};
